// Company name components
export const companyAdjectives = [
  'Nova', 'Ultra', 'Apex', 'Prime', 'Elite', 'Omega', 'Vector', 'Fusion',
  'Global', 'Future', 'Zenith', 'Swift', 'Rapid', 'Smart', 'Quick',
  'Bright', 'Sharp', 'Fast', 'Bold', 'Pure', 'Blue', 'Red', 'Tech'
];

export const companyNouns = [
  'Wave', 'Core', 'Edge', 'Pulse', 'Force', 'Link', 'Beam', 'Flow',
  'Node', 'Flux', 'Grid', 'Sync', 'Path', 'Zone', 'Gate', 'Tech',
  'Labs', 'Works', 'Byte', 'Data', 'Code', 'Net', 'Web', 'Hub'
];

// CEO name components
export const firstNames = [
  'Alexander', 'Benjamin', 'Catherine', 'David', 'Elizabeth',
  'Frederick', 'Grace', 'Henry', 'Isabella', 'James',
  'Katherine', 'Lawrence', 'Margaret', 'Nathan', 'Olivia',
  'Patrick', 'Quinn', 'Rachel', 'Samuel', 'Victoria',
  'William', 'Xavier', 'Yolanda', 'Zachary', 'Andrew',
  'Sophia', 'Michael', 'Emma', 'Daniel', 'Ava'
];

export const lastNames = [
  'Anderson', 'Bennett', 'Carter', 'Davidson', 'Edwards',
  'Foster', 'Graham', 'Hamilton', 'Irving', 'Johnson',
  'Kennedy', 'Kim', 'Lawrence', 'Lee', 'Mitchell', 'Norton', 'Parker',
  'Quinn', 'Roberts', 'Stevens', 'Thompson', 'Walker',
  'Morgan', 'Park', 'Phillips', 'Richardson', 'Wright', 'Young',
  'Harrison', 'Cooper', 'Peterson', 'Watson', 'Brooks'
];

// Phone name components
export const phoneAdjectives = [
  'Pro', 'Max', 'Neo', 'Prime', 'Nova', 'Apex',
  'Alpha', 'Zero', 'Swift', 'Bold', 'Smart', 'Quick',
  'Pure', 'Fast', 'Sharp', 'Red', 'Blue', 'Gold'
];

export const phoneNouns = [
  'Edge', 'Wave', 'Core', 'Flow', 'Link', 'Beam',
  'Touch', 'View', 'Fold', 'Flip', 'Note', 'Pad',
  'Air', 'One', 'Go', 'Zen', 'Fox', 'Sky'
];

export const phoneSuffixes = [
  'Pro', 'Max', 'Plus', 'X', 'S', 'Neo',
  'One', 'Go', 'Air', '5G', 'SE', 'XR',
  'Z', 'V', 'T', 'R', 'M', 'L'
];